var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1915_38515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 50.4161C12.0021 50.4159 12.0024 50.4155 12.0024 50.4151C11.9709 43.4781 13.4632 37.2462 16.4628 31.3789C18.4186 27.5536 20.9188 24.1175 23.9292 21.0478C26.7138 18.2089 29.8251 15.7971 33.2713 13.8185C38.073 11.0617 43.219 9.30008 48.7049 8.5407C51.2089 8.19381 53.7267 8.06956 56.2508 8.18056C61.979 8.43222 67.4416 9.76681 72.6173 12.248C77.0669 14.3818 81.0247 17.2086 84.4741 20.735C89.4384 25.8097 92.937 31.7529 94.9685 38.559C95.8856 41.6312 96.4362 44.7658 96.6677 47.9623C97.1168 54.1622 96.2136 60.1559 93.9398 65.9377C92.2571 70.2165 89.9171 74.1086 86.9559 77.6267C82.8386 82.5173 77.8825 86.3174 72.0893 89.0174C68.3624 90.7544 64.4596 91.9137 60.3858 92.5003C57.7879 92.8743 55.1786 93.013 52.5592 92.8989C47.3123 92.6705 42.2685 91.5365 37.4479 89.4362C32.6961 87.3662 28.4647 84.5217 24.7605 80.8957C20.7302 76.9506 17.6075 72.3842 15.3994 67.1934C13.8737 63.6059 12.8608 59.8803 12.3675 56.0121C12.1159 54.0395 11.9866 52.0619 12.0011 50.4171C12.0011 50.4167 12.0013 50.4163 12.0017 50.4161ZM54.5227 85.4463C54.5227 85.4467 54.5229 85.447 54.5233 85.447C57.314 85.4627 60.0593 85.1133 62.7585 84.4271C67.0941 83.3259 71.0663 81.4413 74.6841 78.8118C79.6169 75.2269 83.4384 70.7046 86.0647 65.1966C88.3605 60.3811 89.4441 55.3051 89.2347 49.9617C89.1319 47.3385 88.7787 44.752 88.1215 42.2114C86.4501 35.7466 83.2669 30.1471 78.4898 25.4666C75.6636 22.6977 72.4558 20.4795 68.8626 18.8226C64.0408 16.5994 58.973 15.5688 53.6649 15.6987C50.9862 15.7643 48.3492 16.1175 45.7538 16.7804C40.3864 18.1522 35.6132 20.6643 31.4366 24.2972C27.9058 27.3688 25.0985 31.0074 23.0197 35.2036C21.1774 38.9229 20.0478 42.8472 19.6454 46.9771C19.3988 49.5057 19.453 52.0329 19.7494 54.5564C20.1821 58.2354 21.1465 61.7649 22.6961 65.1304C25.3363 70.8642 29.2436 75.5504 34.4249 79.1499C40.4607 83.3428 47.1858 85.3825 54.522 85.4457C54.5224 85.4457 54.5227 85.446 54.5227 85.4463Z",
    fill: "url(#paint0_linear_1915_38515)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1915_38515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9046 42.3889C69.9044 42.3888 69.9043 42.3889 69.9043 42.389C69.8865 43.4844 69.5724 44.3256 68.9355 45.0086C67.9326 46.084 66.8995 47.1322 65.8607 48.1729C61.2956 52.7468 56.7274 57.3183 52.1484 61.8783C51.6974 62.3274 51.1954 62.7424 50.6624 63.0893C49.3221 63.9603 47.9787 63.9237 46.7103 62.9398C45.9421 62.3438 45.2401 61.6557 44.5489 60.9682C42.6498 59.0786 40.757 57.1814 38.8914 55.259C37.8847 54.2221 37.3827 52.9758 37.7479 51.517C38.2676 49.4387 40.5072 48.0064 42.822 49.1108C43.3429 49.3593 43.8362 49.7182 44.2556 50.1168C45.664 51.4558 47.0339 52.8358 48.4183 54.2C48.7419 54.5192 48.7848 54.5185 49.0976 54.2063C52.8339 50.4826 56.5672 46.7563 60.3092 43.0389C61.4565 41.8992 62.5861 40.7349 63.8034 39.6727C64.9891 38.6377 66.3962 38.5072 67.8141 39.1688C69.2204 39.8247 69.8215 41.0354 69.9049 42.3888C69.9049 42.3889 69.9047 42.389 69.9046 42.3889Z",
    fill: "url(#paint1_linear_1915_38515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1915_38515",
    x: 0,
    y: 0.141113,
    width: 108.781,
    height: 108.797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1915_38515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1915_38515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1915_38515",
    x: 25.6289,
    y: 30.7622,
    width: 56.2773,
    height: 48.9497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1915_38515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1915_38515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1915_38515",
    x1: 3.51534,
    y1: -18.565,
    x2: 123.003,
    y2: -9.32571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1915_38515",
    x1: 34.3988,
    y1: 30.9044,
    x2: 79.7066,
    y2: 35.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessIcon);
export default __webpack_public_path__ + "static/media/sucessIcon.1dbd95fa42921648cf94086a2da35dd0.svg";
export { ForwardRef as ReactComponent };